import { render, staticRenderFns } from "./SettingTest.vue?vue&type=template&id=44b6f035&scoped=true&"
import script from "./SettingTest.vue?vue&type=script&lang=js&"
export * from "./SettingTest.vue?vue&type=script&lang=js&"
import style0 from "./SettingTest.vue?vue&type=style&index=0&id=44b6f035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b6f035",
  null
  
)

export default component.exports